import { render } from "./TopNews.vue?vue&type=template&id=2e43bfa9&scoped=true"
import script from "./TopNews.vue?vue&type=script&lang=js"
export * from "./TopNews.vue?vue&type=script&lang=js"

import "./TopNews.vue?vue&type=style&index=0&id=2e43bfa9&scoped=true&lang=less"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e43bfa9"]])

export default __exports__